// https://material-ui.com/components/tables/
// fixed header table combined with spanning table features

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

const columns = [
    { id: 'startMonth', label: 'Start Month', minWidth: 10, level: 1 },
    { id: 'endMonth', label: 'End Month', minWidth: 10, level: 1 },
    { id: 'debtName', label: 'Debt', minWidth: 20, level: 2 },
    { id: 'totalPayment', label: 'Payment', minWidth: 20, level: 2, format: value => value.toFixed(2) },
    { id: 'interestToDate', label: 'Total Interest', minWidth: 20, level: 2, format: value => value.toFixed(2) },
    { id: 'paymentsToDate', label: 'Total Payments', minWidth: 20, level: 2, format: value => value.toFixed(2) }
];

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

export default function PayoffSummary(props) {

    const classes = useStyles();

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const totalRows = props.summary.reduce((rows, summary) => {
        return rows += summary.recs.length
    }, 0)

    const tableRows = (summaryRow) => {

        // copy summary recs and shift out the first element
        // because we output the first element on the same row as the start and end month
        const debts = [...summaryRow.recs]
        debts.shift()

        return (
            <React.Fragment>
                <TableRow hover role="checkbox" tabIndex={-1} key={summaryRow.startMonth}>
                    {
                        columns.map((column) => {
                            let value
                            let rtnValue

                            if (column.level === 1) {
                                value = summaryRow[column.id];
                                rtnValue = (
                                    <TableCell rowSpan={summaryRow.recs.length} key={column.id} align={column.align}>
                                        {column.format && typeof value === 'number' ? column.format(value) : value}
                                    </TableCell>
                                )
                            } else if (column.level === 2) {
                                value = summaryRow.recs[0][column.id]

                                // surpress the output of interestToDate and paymentsToDate unless balance is 0
                                if (summaryRow.recs[0].balance != 0.0 && (column.id == "interestToDate" || column.id == "paymentsToDate")) {
                                    // we should always have at least 1 debt
                                    value = null
                                }
                                rtnValue = (
                                    <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === 'number' ? column.format(value) : value}
                                    </TableCell>
                                )

                            }
                            return rtnValue
                        })
                    }
                </TableRow>
                {
                    // output the remaining debts in their own row if any
                    debts.map(debt => {
                        return (
                            <TableRow>
                                {

                                    columns.map((column) => {
                                        let value
                                        let rtnValue = null

                                        if (column.level === 2) {

                                            value = debt[column.id]
                                            if (debt.balance != 0.0 && (column.id == "interestToDate" || column.id == "paymentsToDate")) {
                                            value = null
                                            }

                                            rtnValue = (

                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>

                                            )

                                        }

                                        return rtnValue
                                    })
                                }
                            </TableRow>
                        )

                    })

                }

            </React.Fragment>

        ) // end of return
    }

    return (
        <Paper className={classes.root}>
            <p>Summary</p>
            <TableContainer className={classes.container}>
                <Table stickyHeader size="small" aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.summary.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((summaryRow) => {
                            return tableRows(summaryRow)
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={totalRows}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper >
    );
}
